
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6JR3B", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $a4TK8 = parcelRequire("a4TK8");


var $diswb = parcelRequire("diswb");


var $eEA8O = parcelRequire("eEA8O");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $eqNP8 = parcelRequire("eqNP8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $etJRk = parcelRequire("etJRk");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $dhnmv = parcelRequire("dhnmv");


var $2YJkl = parcelRequire("2YJkl");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $9914C = parcelRequire("9914C");


var $10Oe6 = parcelRequire("10Oe6");


var $hp2SH = parcelRequire("hp2SH");




const $ac5cbd4ec4be996f$export$39d77a27d933af98 = (0, $eSUdr.default)`query GetSpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id name}}`;




const $82ef4889545dda26$export$7e7d1d31b27ce20 = (0, $eSUdr.default)`query GetTemplateInfoQuery($id:ID!){templateInfo(id:$id){author blueprintModuleCompleteKey categoryIds contentBlueprintId description hasGlobalBlueprintContent hasWizard iconURL darkModeIconURL isFavourite isNew isPromoted itemModuleCompleteKey link links{base context}name recommendationRank spaceKey styleClass templateId templateType}}`;


const $b9b360f49f6b8c27$var$_getSpaceNameQuery = async (variables)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (await (0, $hp2SH.getApolloClient)().query({
        query: (0, $ac5cbd4ec4be996f$export$39d77a27d933af98),
        variables: variables
    })).data;
};
const $b9b360f49f6b8c27$var$_getTemplateInfoQuery = async (variables)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (await (0, $hp2SH.getApolloClient)().query({
        query: (0, $82ef4889545dda26$export$7e7d1d31b27ce20),
        variables: variables
    })).data;
};
const $b9b360f49f6b8c27$export$16170ffac8499884 = async (spaceKey)=>{
    const spaceNameData = await $b9b360f49f6b8c27$var$_getSpaceNameQuery({
        spaceKey: spaceKey
    });
    return spaceNameData?.space?.name;
};
const $b9b360f49f6b8c27$export$1cdee53a58be8108 = async (id)=>{
    const templateData = await $b9b360f49f6b8c27$var$_getTemplateInfoQuery({
        id: id
    });
    return templateData?.templateInfo;
};















var $jn9ek = parcelRequire("jn9ek");

const $db5fd6a8f635d615$export$19da93f73216ea0b = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const startCreatePageExperience = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            attributes: {
                flow: 'createFromTemplateMacro',
                edition: edition
            }
        });
    }, [
        experienceTracker,
        edition
    ]);
    const succeedCreatePageExperience = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            attributes: {
                flow: 'createFromTemplateMacro'
            }
        });
    }, [
        experienceTracker
    ]);
    const stopCreatePageExperienceOnError = (0, $42omo.useCallback)((error)=>{
        const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
        if (!cteTraceId) // When the error does not contain trace id, it's presumed that the network call failed due to network issue, thus aborting the experience
        experienceTracker.abort({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            reason: `${(0, $irVI7.CREATE_PAGE_EXPERIENCE)} aborted due to presumed client network failure`,
            attributes: {
                error: error?.message
            }
        });
        else experienceTracker.stopOnError({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            error: error,
            attributes: {
                cteTraceId: cteTraceId
            }
        });
    }, [
        experienceTracker
    ]);
    return {
        startCreatePageExperience: startCreatePageExperience,
        succeedCreatePageExperience: succeedCreatePageExperience,
        stopCreatePageExperienceOnError: stopCreatePageExperienceOnError
    };
};






var $inPa6 = parcelRequire("inPa6");

const $29ff38e73df920b8$export$27deda0da73c7cc7 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const createCFTMacroAnalyticsEvent = (0, $42omo.useCallback)(({ source: source = 'createFromTemplateMacro', type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        createAnalyticsEvent({
            type: type,
            data: {
                source: source,
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return createCFTMacroAnalyticsEvent;
};


const $92464a6d16d62abd$var$i18n = (0, $cgtv4.defineMessages)({
    createFromTemplateDefaultLabelText: {
        id: "create-from-template.inline-extension.create-from-template",
        defaultMessage: "Create from Template"
    },
    createFromTemplateError: {
        id: "create-from-template.inline-extension.create-from-template.error",
        defaultMessage: "You might not have permission to add content in the destination space. Check permissions, or edit the space key in the Create From Template macro."
    },
    unavailableTemplateError: {
        id: "create-from-template.inline-extension.create-from-template.unavailable-template.error",
        defaultMessage: "The original template has been deleted. Select a new template for the Create From Template macro."
    },
    notFoundError: {
        id: "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error",
        defaultMessage: "Refresh the page to try again."
    },
    notFoundErrorTitle: {
        id: "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn\u2019t create new content for you"
    }
});
const $92464a6d16d62abd$var$CreateFromTemplateContainer = ({ macroDefaultProps: macroDefaultProps, flags: flags, isPreviewMode: isPreviewMode, ssrButtonLabel: ssrButtonLabel })=>{
    const { node: node, mode: mode, contentId: contentId, extensionKey: extensionKey } = macroDefaultProps;
    const [showLoading, setShowLoading] = (0, $42omo.useState)(false);
    const [macroParams, setMacroParams] = (0, $42omo.useState)({});
    const [currentTemplate, setCurrentTemplate] = (0, $42omo.useState)();
    const [isPageType, setIsPageType] = (0, $42omo.useState)(false);
    const { buttonLabel: userConfiguredButtonLabel, createButtonLabel: macroButtonLabel, contentBlueprintId: contentBlueprintId, templateId: templateId, spaceKey: spaceKey, blueprintModuleCompleteKey: blueprintModuleCompleteKey, title: pageTitle, pageType: pageType } = macroParams;
    const intl = (0, $8C5kA.default)();
    const buttonLabel = ssrButtonLabel || userConfiguredButtonLabel || macroButtonLabel || intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateDefaultLabelText);
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const createCFTMacroAnalyticsEvent = (0, $29ff38e73df920b8$export$27deda0da73c7cc7)();
    const { startCreatePageExperience: startCreatePageExperience, stopCreatePageExperienceOnError: stopCreatePageExperienceOnError, succeedCreatePageExperience: succeedCreatePageExperience } = (0, $db5fd6a8f635d615$export$19da93f73216ea0b)();
    const isSameSpace = spaceKey === macroDefaultProps?.spaceKey;
    const name = (0, $5kjCz.getExperienceName)(mode, node);
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const { userId: userId, isLicensed: isLicensed, timeZone: timeZone } = (0, $bQm3c.useSessionData)();
    const updateCustomTitle = async ()=>{
        if (pageTitle) {
            let title = pageTitle;
            if (title.includes('@spaceName')) {
                const spaceName = await (0, $b9b360f49f6b8c27$export$16170ffac8499884)(spaceKey);
                title = title.replace(/@spaceName/g, `${spaceName}`);
            }
            if (title.includes('@currentDate')) {
                const currentDate = (0, $9914C.getUserTimezoneDate)({
                    userId: userId,
                    isLicensed: isLicensed,
                    timeZone: timeZone,
                    dateFormat: 'yyyy-MM-dd'
                });
                title = title.replace(/@currentDate/g, `${currentDate}`);
            }
            title = title.replace(/@spaceKey/g, `${spaceKey}`);
            return title;
        }
        return '';
    };
    const { data: contentTypeQueryData, error: contentTypeQueryError, loading: contentTypeQueryLoading } = (0, $diswb.useQuery)((0, $eSUdr.default)`query CreateFromTemplateGetContentTypeQuery($contentId:ID!){singleContent(id:$contentId){id type}}`, {
        variables: {
            contentId: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (contentTypeQueryLoading) return;
        if (contentTypeQueryError) {
            if ((0, $1uFM6.isUnauthorizedError)(contentTypeQueryError) || (0, $f9jv7.isNotFoundError)(contentTypeQueryError)) (0, $7Sm4c.markErrorAsHandled)(contentTypeQueryError);
            else (0, $5ZqQS.getMonitoringClient)().submitError(contentTypeQueryError, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
        } else setIsPageType(contentTypeQueryData?.singleContent?.type === 'page');
    }, [
        contentTypeQueryData,
        contentTypeQueryError,
        contentTypeQueryLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        const unwrapMacroParameters = ()=>{
            const macroParams = Object.keys(node.parameters.macroParams);
            const unwrappedParams = macroParams.reduce((acc, parameter)=>{
                if (!acc[parameter]) acc[parameter] = node.parameters.macroParams[parameter]?.value;
                return acc;
            }, {});
            setMacroParams(unwrappedParams);
        };
        unwrapMacroParameters();
    }, [
        node
    ]);
    const template = {
        contentBlueprintId: contentBlueprintId || null,
        templateId: templateId || null,
        blueprintModuleCompleteKey: blueprintModuleCompleteKey || null
    };
    const getSelectedTemplateInfo = async ()=>{
        const fetchedTemplate = await (0, $b9b360f49f6b8c27$export$1cdee53a58be8108)(templateId || contentBlueprintId || blueprintModuleCompleteKey);
        return fetchedTemplate ? {
            ...template,
            contentBlueprintId: fetchedTemplate.contentBlueprintId,
            hasWizard: fetchedTemplate.hasWizard,
            itemModuleCompleteKey: fetchedTemplate.itemModuleCompleteKey,
            iconURL: fetchedTemplate.iconURL,
            darkModeIconURL: fetchedTemplate.darkModeIconURL,
            blueprintModuleCompleteKey: blueprintModuleCompleteKey || fetchedTemplate?.blueprintModuleCompleteKey,
            name: fetchedTemplate.name
        } : null;
    };
    const handleMouseOver = async (showPreview, e)=>{
        const target = e?.currentTarget;
        e.persist();
        try {
            const selectedTemplate = await getSelectedTemplateInfo();
            setCurrentTemplate(selectedTemplate);
            experienceTracker.start({
                name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_PREVIEW,
                attributes: {
                    source: 'createFromTemplateMacro',
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(selectedTemplate)
                }
            });
            showPreview(selectedTemplate, target?.getBoundingClientRect(), 0);
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else handleTemplatePreviewError(error);
        }
    };
    const { showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate: showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate } = (0, $etJRk.useLoomAiMeetingNotesSideNavCardActions)();
    const createContentFromTemplate = async ()=>{
        setShowLoading(true);
        startCreatePageExperience();
        try {
            const isTargetPageLive = pageType == 'live' && (0, $9wGTI.fg)('cft_macro_create_live_doc');
            createCFTMacroAnalyticsEvent({
                type: 'sendUIEvent',
                source: 'createFromTemplateMacro',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'useTemplate',
                attributes: {
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                    isTargetPageLive: isTargetPageLive
                }
            });
            const title = await updateCustomTitle();
            const selectedTemplate = await getSelectedTemplateInfo();
            if (!selectedTemplate) {
                succeedCreatePageExperience();
                return await flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.unavailableTemplateError)
                });
            }
            await createFromTemplate(selectedTemplate, spaceKey, {
                title: title,
                parentPageId: isPageType && isSameSpace ? contentId : '',
                openContentInNewTab: true,
                subType: isTargetPageLive ? pageType : undefined
            });
            if ((0, $9wGTI.fg)('loom_ai_meeting_notes_in_confluence_killswitch')) showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate(template.blueprintModuleCompleteKey || template.templateId || '', ()=>{
                createCFTMacroAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    action: 'fail',
                    actionSubject: 'loomAiMeetingNotesInConfluence.setLocalStorageItem',
                    source: 'QuickTemplateCard',
                    attributes: {
                        id: template.blueprintModuleCompleteKey || template.templateId || ''
                    }
                });
            });
        } catch (error) {
            if ((0, $f9jv7.isNotFoundError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.notFoundErrorTitle),
                    description: intl.formatMessage($92464a6d16d62abd$var$i18n.notFoundError)
                });
            } else if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateError)
                });
            } else handleCreateFromTemplateError(error);
        } finally{
            setShowLoading(false);
        }
    };
    const handleCreateFromTemplateError = (error)=>{
        stopCreatePageExperienceOnError(error);
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        createCFTMacroAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'error',
            actionSubject: 'createFromTemplateMacro',
            actionSubjectId: 'contentCreateWithTemplateError',
            attributes: {
                errorMessage: error.message
            }
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        flags.showErrorFlag({
            title: intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateError)
        });
    };
    const handleTemplatePreviewError = (error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
            error: error,
            attributes: {
                source: 'createFromTemplateMacro'
            }
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        createCFTMacroAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'error',
            actionSubject: 'createFromTemplateMacro',
            actionSubjectId: 'templatePreview',
            attributes: {
                errorMessage: error.message
            }
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhnmv.PopupPreview), {
        spaceKey: spaceKey || macroDefaultProps?.spaceKey,
        templates: [
            currentTemplate
        ],
        hoverSource: "createFromTemplateMacro",
        hasDynamicPositioning: true,
        isEditorView: false
    }, ({ showPreview: showPreview, hidePreview: hidePreview })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            isDisabled: isPreviewMode,
            onClick: createContentFromTemplate,
            onMouseEnter: (e)=>handleMouseOver(showPreview, e),
            onFocus: (e)=>handleMouseOver(showPreview, e),
            onMouseLeave: hidePreview,
            onBlur: hidePreview
        }, buttonLabel)), showLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: name,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $92464a6d16d62abd$export$a6c71275c6598127 = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})((0, $7aRa9.withFlags)($92464a6d16d62abd$var$CreateFromTemplateContainer)), (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
module.exports["CreateFromTemplate"] = $92464a6d16d62abd$export$a6c71275c6598127;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154i1ssb _1ltv1ssb _t9ec1ooe _1pby1ap8",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v5641p41 _1pbybfng _4t3i1osq _1bsb1osq _kqsw1n9t _1ltvidpf _154iidpf _bfhkvuon _tzy47u59 _1lww1yx9",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("etJRk", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $5GjsS = parcelRequire("5GjsS");

const $4b46d4dc3abd42c4$var$logger = (0, $7W8i8.getLogger)('useLoomAiMeetingNotesSideNavCardListener');
const $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS = [
    'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:page-led-meetings-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint'
];
const $4b46d4dc3abd42c4$var$isAcceptedTemplateId = (templateId)=>{
    return $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS.includes(templateId);
};
const $4b46d4dc3abd42c4$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        isSideNavCardEligible: false
    },
    actions: {
        showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate: (templateId, onLocalStorageFail)=>({ setState: setState })=>{
                if ($4b46d4dc3abd42c4$var$isAcceptedTemplateId(templateId)) {
                    try {
                        /**
						 * Reason we are using local storage:
						 * - it persists across browser sessions and tab closures, ensuring the user's interaction is remembered
						 * - This is important for the "create from template" macro which opens the template in a new tab (instead of same page)
						 */ (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $5GjsS.USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY), true);
                    } catch (setError) {
                        /**
						 * this is here to avoid uncaught storage errors
						 */ $4b46d4dc3abd42c4$var$logger.error`An error occurred while setting local storage: ${setError}`;
                        onLocalStorageFail?.();
                    }
                    setState({
                        isSideNavCardEligible: true
                    });
                }
            }
    }
});
const $4b46d4dc3abd42c4$export$b24c0c9f7b270c76 = (0, $9zUhf.createStateHook)($4b46d4dc3abd42c4$var$store);
const $4b46d4dc3abd42c4$export$3608a4533235df3f = (0, $9zUhf.createActionsHook)($4b46d4dc3abd42c4$var$store);
module.exports["useLoomAiMeetingNotesSideNavCardState"] = $4b46d4dc3abd42c4$export$b24c0c9f7b270c76;
module.exports["useLoomAiMeetingNotesSideNavCardActions"] = $4b46d4dc3abd42c4$export$3608a4533235df3f;

});

parcelRegister("5GjsS", function(module, exports) {
const $fb693db220d77333$export$f8ada5a979213a3d = 'lamnic-user-clicked-on-meeting-notes';
module.exports["USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY"] = $fb693db220d77333$export$f8ada5a979213a3d;

});

parcelRegister("dhnmv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9a42d0df36d411bd$export$65c74394172c28e5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2ysmR",
    name: "PopupPreview",
    loader: async ()=>(await (parcelRequire("eLguG"))).PopupPreview
});
module.exports["PopupPreview"] = $9a42d0df36d411bd$export$65c74394172c28e5;

});

parcelRegister("eLguG", function(module, exports) {

let $abf23fd1e6621c61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abf23fd1e6621c61$var$load("6wr18"),
    $abf23fd1e6621c61$var$load("e1cuZ"),
    $abf23fd1e6621c61$var$load("6kXh6"),
    $abf23fd1e6621c61$var$load("hvHZS"),
    $abf23fd1e6621c61$var$load("iXzmH"),
    $abf23fd1e6621c61$var$load("65c4i"),
    $abf23fd1e6621c61$var$load("7EorR"),
    $abf23fd1e6621c61$var$load("ffEVr"),
    $abf23fd1e6621c61$var$load("Wowvf"),
    $abf23fd1e6621c61$var$load("bupWa")
]).then(()=>parcelRequire('bEmzp'));

});

parcelRegister("9914C", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $72P30 = parcelRequire("72P30");

const $baec9e3e3fc5ba98$export$df19e8e99fa12ca2 = ({ userId: userId, isLicensed: isLicensed, timeZone: timeZone, dateFormat: dateFormat })=>{
    const isAnonymousUser = !userId || !isLicensed;
    const isLicensedWithTimezone = timeZone && !isAnonymousUser;
    const date = new Date();
    const currentTimezoneDate = isLicensedWithTimezone ? (0, $72P30.default)(date, timeZone, dateFormat) : (0, $dWCFT.default)(date, dateFormat);
    return currentTimezoneDate;
};
module.exports["getUserTimezoneDate"] = $baec9e3e3fc5ba98$export$df19e8e99fa12ca2;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});

parcelRegister("bZ9Ng", function(module, exports) {
/* This module exports shared functions used by both blueprint & template endpoints, as these REST APIs share similar
 * request/response patterns.
 */ // eslint-disable-next-line no-restricted-imports

var $hBkCm = parcelRequire("hBkCm");


var $dw6y2 = parcelRequire("dw6y2");

const $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f = (json)=>{
    const title = json?.content?.title;
    return {
        content: {
            id: json?.content?.id || null,
            type: 'page',
            subType: json?.content?.subType || null,
            title: typeof title === 'string' ? title : null,
            space: {
                key: json?.content?.space?.key || null
            },
            _links: {
                editui: json?.content?._links?.editui || null
            },
            metadata: {
                properties: {
                    editor: {
                        value: json?.content?.metadata?.properties?.editor?.value || null
                    }
                },
                simple: {
                    isFabric: json?.content?.metadata?.simple?.isFabric || null
                }
            }
        }
    };
};
const $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4 = async (cfetch, url, method, headers, pageData)=>{
    const MAX_CONTENT_UPDATE_RETRY = 1;
    const updateTemplate = async (count = 0)=>{
        try {
            const res = await cfetch(url, {
                method: method,
                headers: headers,
                body: JSON.stringify(pageData)
            });
            return res.json();
        } catch (err) {
            const errorStatus = err?.response?.status;
            if (errorStatus === 500) {
                const backendError = await err.response.json();
                throw new (0, $hBkCm.BadStatusError)(backendError.errorMessage, err.response);
            }
            if (count < MAX_CONTENT_UPDATE_RETRY && errorStatus === 409) return updateTemplate(++count);
            throw err;
        }
    };
    const json = await updateTemplate();
    return $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f(json);
};
const $2dc0a210c1f3c9f7$export$6a221318e0d372a4 = async (createPageResponseJson, attemptSpaUrl)=>{
    if (attemptSpaUrl) {
        // TODO: remove the old metadata field check once we use the new metadata field for template
        const isFabric = createPageResponseJson?.content?.metadata?.properties?.editor?.value === 'v2' || createPageResponseJson?.content?.metadata?.simple?.isFabric === true;
        const isLivePage = createPageResponseJson?.content?.subType === 'live';
        if (isLivePage) return createPageResponseJson?.content?._links?.editui;
        if (isFabric) return (0, $dw6y2.createEditDraftPageUrl)(createPageResponseJson);
    }
    return createPageResponseJson?.content?._links?.editui;
};
module.exports["getOnContentUpdatedObjFromResponse"] = $2dc0a210c1f3c9f7$export$79d30bcd36f6be4f;
module.exports["updateContentWithRetry"] = $2dc0a210c1f3c9f7$export$ed7023388c8f5dd4;
module.exports["getEditDraftPageUrl"] = $2dc0a210c1f3c9f7$export$6a221318e0d372a4;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams)=>{
    setQueryParams({
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    }, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, queryParamValue)=>{
    setQueryParams({
        [$4a3de077c1d50444$export$339879d9e7e1b505]: queryParamValue
    }, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});


//# sourceMappingURL=CreateFromTemplate.f72a6fb9.js.map
